<script>
import ListCategory from "@/components/admin/category/ListCategory.vue";

export default {
  name: 'ListCategoryAdminView',
  components: {ListCategory}
}
</script>

<template>
  <div>
    <list-category />
  </div>
</template>